const compare = (a, b) => {
  if (a.length !== b.length) {
    return false;
  }

  return a.every((x, index) => x === b[index]);
};

export default compare;
